export default {
  'menu.welcome': 'Chào mừng',
  'menu.more-blocks': 'Thêm Block',
  'menu.home': 'Trang chủ',
  'menu.admin': 'Quản trị',
  'menu.admin.sub-page': 'Trang phụ',
  'menu.login': 'Đăng nhập',
  'menu.register': 'Đăng ký',
  'menu.register-result': 'Kết quả đăng ký',
  'menu.dashboard': 'Bảng điều khiển',
  'menu.dashboard.analysis': 'Phân tích',
  'menu.dashboard.monitor': 'Giám sát',
  'menu.dashboard.workplace': 'Thống kê',
  'menu.user-management': 'Quản lý user',
  'menu.leaderboard': 'Bảng xếp hạng',
  'menu.banner-management': 'Quản lý banner',
  'menu.post-management': 'Quản lý bài viết',
  'menu.exception.403': '403',
  'menu.exception.404': '404',
  'menu.exception.500': '500',
  'menu.form': 'Biểu mẫu',
  'menu.form.basic-form': 'Biểu mẫu cơ bản',
  'menu.form.step-form': 'Biểu mẫu từng bước',
  'menu.form.step-form.info': 'Biểu mẫu từng bước (nhập thông tin chuyển khoản)',
  'menu.form.step-form.confirm': 'Biểu mẫu từng bước (xác nhận thông tin chuyển khoản)',
  'menu.form.step-form.result': 'Biểu mẫu từng bước (hoàn thành)',
  'menu.form.advanced-form': 'Biểu mẫu nâng cao',
  'menu.list': 'Danh sách',
  'menu.list.table-list': 'Bảng truy vấn',
  'menu.list.basic-list': 'Danh sách cơ bản',
  'menu.list.card-list': 'Danh sách thẻ',
  'menu.list.search-list': 'Danh sách tìm kiếm',
  'menu.list.search-list.articles': 'Danh sách tìm kiếm (bài viết)',
  'menu.list.search-list.projects': 'Danh sách tìm kiếm (dự án)',
  'menu.list.search-list.applications': 'Danh sách tìm kiếm (ứng dụng)',
  'menu.profile': 'Trang chi tiết',
  'menu.profile.basic': 'Chi tiết cơ bản',
  'menu.profile.advanced': 'Chi tiết nâng cao',
  'menu.result': 'Trang kết quả',
  'menu.result.success': 'Trang thành công',
  'menu.result.fail': 'Trang thất bại',
  'menu.exception': 'Trang ngoại lệ',
  'menu.exception.not-permission': '403',
  'menu.exception.not-find': '404',
  'menu.exception.server-error': '500',
  'menu.exception.trigger': 'Kích hoạt',
  'menu.account': 'Tài khoản',
  'menu.account.center': 'Trung tâm tài khoản',
  'menu.account.settings': 'Cài đặt tài khoản',
  'menu.account.trigger': 'Kích hoạt lỗi',
  'menu.account.logout': 'Đăng xuất',
  'menu.apartments': 'Căn hộ',
  'menu.apartments.list': 'Danh sách căn hộ',
  'menu.apartments.management': 'Quản lý căn hộ',
  'menu.editor': 'Trình chỉnh sửa đồ họa',
  'menu.editor.flow': 'Trình chỉnh sửa luồng',
  'menu.editor.mind': 'Trình chỉnh sửa sơ đồ tư duy',
  'menu.editor.koni': 'Trình chỉnh sửa Koni',
};
